<div class="container">
	<header>
		<h3 class="text" i18n> Печатная форма </h3>
		<app-icon (click)="close()">close</app-icon>
	</header>
	<main [formGroup]="form">
		<section class="format-choice">
			<label i18n>Выберите формат:</label>
			<app-tab formControlName="outputType" [tabs]="getOutputTypeValues()" [newStyle]="true"></app-tab>
		</section>
		<section class="additions-checks">
			<ng-container *ngIf="(documentType === 'EWAYBILL' && formType !== 2) || documentType === 'EACTDIF'">
				<div class="row" (click)="toggleControlValue('shortForm')">
					<app-icon>
						{{ form.controls.shortForm.value ? 'check_box' : 'check_box_outline_blank' }}
					</app-icon>
					<label i18n>Печатать дополнительные сведения</label>
				</div>
			</ng-container>
			<ng-container *ngIf="!usedSignApi && viewCheckBox">
				<div class="row" (click)="toggleControlValue('printEds')">
					<app-icon>
						{{ form.controls.printEds.value ? 'check_box' : 'check_box_outline_blank' }}
					</app-icon>
					<label i18n>{{ "Печать " + (["ME", "KZ", "CTT"].includes(env.project) && allowedDocumentTypes?.includes(documentType!) ? "штампа" : "") + " ЭЦП" }}</label>
				</div>
			</ng-container>
		</section>
	</main>
	<footer>
		<button class="save" appSkin="action-save bold" (click)="printData()" i18n>Печать</button>
		<button i18n type="button" appSkin="simple no-shadow bold bordered" (click)="close()">Отмена</button>
	</footer>
</div>
